var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreference(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    focusable: "false",
    className: "chakra-icon css-3cy68l",
    "aria-label": "heart-check",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.70838C12.9139 4.61057 14.2732 3.98202 15.7015 3.99667C18.8729 3.99667 21.0037 6.97791 21.0037 9.75406C21.0037 15.5575 13.7787 20.0033 12 20.0033C10.2213 20.0033 2.99625 15.5575 2.99625 9.75406C2.99625 6.97791 5.12713 3.99667 8.29845 3.99667C9.72683 3.98202 11.0861 4.61057 12 5.70838Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8548 10.5744L11.5378 12.8934L10.1452 11.4998"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreference);
export default __webpack_public_path__ + "static/media/preference.5a70c0549d5948e3cb712fde2c52a8e8.svg";
export { ForwardRef as ReactComponent };